function initGsap() {
    gsap.registerPlugin(ScrollTrigger);

    // ScrollSmoother removed 2026-09-14 — it re-implemented scrolling via JS
    // transforms (continuous main-thread rAF work for the whole session) and
    // was the reason #smooth-wrapper sat at opacity:0 until `window.load`
    // (see snippets/critical-css.liquid history / dev-logs/motion/gsap.md).
    // Its `effects: true` / data-speed parallax is now driven by
    // assets/global-animations.js instead (no GSAP dependency).

    // Defer ScrollTrigger's automatic refresh so it doesn't block the main
    // thread immediately after load (avoids long tasks blocking scroll input).
    ScrollTrigger.config({ autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load,resize' });

    // Header shrink-on-scroll and .js-invert-header color inversion used to
    // live here as a GSAP matchMedia timeline + per-section ScrollTriggers.
    // Rebuilt in vanilla JS on <header-component> itself (assets/header.js)
    // — see dev-logs/motion/gsap.md, "Step 1", for why.
}

window.addEventListener('load', () => {
    initGsap();
    document.body.classList.add('gsap-ready');
});
